<template src= "./index.html"></template>

<script>
import isEmpty from 'lodash/isEmpty'
import { parseISO, format } from 'date-fns'
import optionData from '@/optionData/data'
import {ko} from 'vuejs-datepicker/dist/locale'
import { Tag } from 'element-ui'
import moment from 'moment'
import agTableComp from '@/optionData/agTableComp'

export default {
  name: 'artistList',
  
    data () {
        return {
            ko : ko,
            optionData : optionData,
            //급계약코드(디폴트) / Email ID / 권리자명 / 회사
            keywordOption :[
                {value: 'ref_code', label:'DJ코드'},
            ],
            keywordType :'ref_code',
            keyword : '',
            
            stateOption : [
                {value: 'success', label: '전송성공'},
                {value: 'error', label: '전송실패'},
                {value: 'is_delivering', label: '전송'},
                {value: 'await_delivery', label: '전송대기'},
                {value: 'temporary', label: '등록'},
                {value: 'is_packaging', label: '패키징'},
                {value: 'await_packagin', label:'패키징 대기'},
            ],
            state : null,
            contract : null,
            contractOption : [

            ],
            'success' : '전송성공',
            'error' : '전송실패',
            'is_delivering' : '전송',
            'await_delivery' : '전송대기',
            'temporary' : '등록',
            'is_packaging' : '패키징',
            'await_packaging':'패키징 대기',

            startDate :null,
            endDate : null,
            dateType :'created_at' ,
            dateOption : [
                {value: 'created_at',label: '등록일',},
                {value: 'start_date',label: '작업시작일',},
                {value: 'end_date',label: '작업종료일',},
            ],
            total : 0,
            filtered:0,
            page: {
                pageSize : 10,
                currentPage: 1,                       // 현재 페이지
                totalPage: 0,                         // 총 페이지수
            },          
            gridOptions :{ // 테이플 옵션
                onRowClicked: (event)=>{
                    //this.viewDetail(event)
                },
                frameworkComponents : {
                    ...agTableComp
                },
                context: {
                    componentParent: this
                },
                getRowHeight:(params)=>{
                    return 80;
                }
            },
            defaultColDef: {
                sortable: false,
                editable: false,
                resizable: true,
                suppressMenu: false,
                rowSelection:'single'
            },
            
            columnDefs: [

                // album_count: 1
                // amount_remaining: 40072232.84693845
                // amount_total: 42906150
                // created_at: "2021-12-13T07:11:07.445Z"
                // end_date: null
                // id: 5
                // licensor_id: 1813
                // ref_code: "AP0005"
                // service_fee: 15
                // start_date: "2021-10-21"
                // updated_at: "2022-01-05T02:44:11.094Z"
                // user_company: "리플라이프로젝트"
                // licensor.currency: "krw"
                // user_email: "reflyproject@soundrepublica.com"
                // user_family_name: "노"
                // user_given_name: "건식"
                // user_name: "노 건식"

                {headerName: 'DJ 코드', field: 'ref_code', filter: false,width: 180,
                    cellRendererParams: {
                        clicked: function(data) {
                            this.context.componentParent.viewDetail(data.id);
                        },
                    },
                    cellRendererSelector: (data) => {
                        let dd={
                            component: 'textButton',
                            params: {
                                ...data.data,
                                text: data.value,
                                style: 'color: rgba(var(--vs-primary), 1); cursor : pointer'
                            }
                        } ;
                        // if(this.selectTrack.track_id ==  data.data.track_id ){
                        //     dd.params['disabled'] = true
                        //     dd.params['title'] = '선택완료'
                        // }
                        
                        return dd
                    }
                },
                {headerName: 'DJ 계약사',  field: 'export_contract',  filter: false,width: 250,cellRenderer: (data) => {
                    let t = data.value.name
                    
                    return `<div class="cellCenter"><span>${t}</span></div>`
                }},
                
                {headerName: 'Batch 수',  field: 'id',  filter: false,width: 150,cellRenderer: (data) => {
                    
                    let t = this.numberFormat(data.data.album_count)
                    let l = this.numberFormat(data.data.track_count)
                    
                    return `<div class="cellCenter"><span>${t} 앨범</span> <span>${l} 트랙</span> </div>`
                }},
                {headerName: 'DJ 상태',  field: 'state',  filter: false,width: 180,cellRenderer: (data) => {
                    //      success, error, is_delivering,await_delivery, temporary , is_packaging , await_packaging
                    let text ={
                        'success' : '전송성공',
                        'error' : '전송실패',
                        'is_delivering' : '전송',
                        'await_delivery' : '전송대기',
                        'temporary' : '등록',
                        'is_packaging' : '패키징',
                        'await_packaging':'패키징 대기',
                    }
                    let color ={
                        'success' : '#239351',
                        'error' : '#f9383f',
                        'is_delivering' : '#a412b5',
                        'await_delivery' : '#a457ad',
                        'temporary' : '#545353',
                        'is_packaging' : '#3340ed',
                        'await_packaging':'#529adb',
                    }
                    let t = data.value
                    
                    return `<div class="cellCenter"><span class="textCenter" style=" min-width:80px; color:#fff; padding: 3px 8px; border-radius:8px; background : ${color[t]}">${text[t]}</span></div>`
                }},
                {headerName: 'Batch 수',  field: 'id',  filter: false,width: 180,cellRenderer: (data) => {
                    
                    let t = this.numberFormat(data.data.pkg_err_count)
                    let l = this.numberFormat(data.data.del_err_count)
                    let s = this.numberFormat(data.data.success_count)

                    
                    return `<div class="cellCenter">
                        <span style="${t > 0 ? 'color:#b52581': ''}">패키지실패 (${t})</span> 
                        <span style="${l > 0 ? 'color:#b52581': ''}">전송실패 (${l})</span> 
                        <span style="${s > 0 ? 'color:#33c546': ''}">전송완료 (${s})</span> 
                    </div>`
                }},
                {headerName: '등록일시',      field: 'created_at',     filter: false,width: 200, cellRenderer: (data) => {
                     return `<div class="cellCenter"><span>${data.value ? this.fixDate(data.value , 'yyyy-MM-dd HH:mm') : ''}</span></div>`
                }},
                
                {headerName: '작업시작일시',      field: 'started_at',     filter: false,width: 200, cellRenderer: (data) => {
                     return `<div class="cellCenter"><span>${data.value ? this.fixDate(data.value , 'yyyy-MM-dd HH:mm') : ''}</span></div>`
                }},
                {headerName: '작업종료일시',      field: 'finished_at',     filter: false,width: 200, cellRenderer: (data) => {
                     return `<div class="cellCenter"><span>${data.value ? this.fixDate(data.value , 'yyyy-MM-dd HH:mm') : ''}</span></div>`
                }},
                // {headerName: '누적상계금액',  field: 'amount_remaining',  filter: false,width: 180,cellRenderer: (data) => {
                //     let demical = 1
                //     if(data.data.licensor.currency == 'krw' ){demical = 0}
                //     let t = this.numberFormat((data.data.amount_total - data.data.amount_remaining)) + ''+ data.data.licensor.currency.toUpperCase()
                    
                //     return `<div class="cellCenter"><span>${t}</span></div>`
                // }},
                // {headerName: '선급금잔액',  field: 'amount_remaining',  filter: false,width: 180,cellRenderer: (data) => {
                //     let demical = 1
                //     if(data.data.licensor.currency == 'krw' ){demical = 0}
                //     let t = this.numberFormat(data.value , demical ) + ''+ data.data.licensor.currency.toUpperCase()
                    
                //     return `<div class="cellCenter"><span>${t}</span></div>`
                // }},
                // {headerName: '선급정산요율',  field: 'service_fee',  filter: false,width: 110,cellRenderer: (data) => {
                //     let t = this.numberFormat(data.value) + '%'
                    
                //     return `<div class="cellCenter"><span>${t}</span></div>`
                // }},
             
                // {headerName: 'Email ID',      field: 'licensor.user.email',     filter: false,width: 300, cellRenderer: (data) => {
                //     return `<div class="cellCenter"><span>${data.value}</span></div>`
                // }},
                // {headerName: '권리자명',      field: 'licensor',     filter: false,width: 200, cellRenderer: (data) => {
                //     let name = `${(data.value.family_name ? data.value.family_name : '')} ${(data.value.given_name ? data.value.given_name : '')}`
                //     var pattern3 = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/; //한글
                //     if(pattern3.test(name)){
                //         name = `${(data.value.family_name ? data.value.family_name : '')} ${(data.value.given_name ? data.value.given_name : '')}`
                //     }else{
                //         name = `${(data.value.given_name ? data.value.given_name : '')} ${(data.value.family_name ? data.value.family_name : '')}` 
                //     }
                //     return `<div class="cellCenter"><span>${name}</span></div>`
                // }},
                // {headerName: '회사명',      field: 'licensor.company',     filter: false,width: 200, cellRenderer: (data) => {
                //     return `<div class="cellCenter"><span>${data.value ? data.value : ''}</span></div>`
                // }},                
                // {headerName: '정산화폐',      field: 'licensor.currency',     filter: false,width: 100, cellRenderer: (data) => {
                //     return `<div class="cellCenter"><span>${data.value.toUpperCase()}</span></div>`
                // }},
                // {headerName: '등록일시',      field: 'created_at',     filter: false,width: 200, cellRenderer: (data) => {
                //      return `<div class="cellCenter"><span>${this.fixDate(data.value)}</span></div>`
                // }},
                // {headerName: '메모',      field: 'description',     filter: false,width: 400, cellRenderer: (data) => {
                //     return `<div class="cellCenter"><span class="text3line">${data.value}</span></div>`
                    
                // }},
            ],
            tableData:[
            ],       
            
        }
    },
    created(){
        if(this.$route.query.page){
            this.page.currentPage = Number(this.$route.query.page)
        }
        if(this.$route.query.keywordType){
            this.keywordType = this.$route.query.keywordType
        }
        if(this.$route.query.keyword){
            this.keyword = this.$route.query.keyword
        }
        if(this.$route.query.state){
            this.state = this.$route.query.state
        }
        if(this.$route.query.contract){
            this.contract = this.$route.query.contract
        }
        if(this.$route.query['date_field']) {
            this.dateType = this.$route.query['date_field'] 
        }
        if(this.$route.query['date_start'] ) {
            this.startDate = this.$route.query['date_start'] 
        }
        
      
    },
    mounted(){
        this.$nextTick(() =>{
        this.callList()
        })
    },
    watch: {
        'page.currentPage'(e){
            
            this.callList()
        },
        'page.pageSize'(){
            this.list_search()
        }
    },
    methods: {
        resetSearch (){
            this.page.currentPage = 1
            this.keywordType = null
            this.keyword = ''
            this.dateType = null
            this.startDate = null
            this.endDate = null
            this.callList() 
        },
        callList(){
            const option = {
                sort : 'ref_code',
                sortorder: 'desc',
                page: this.page.currentPage-1 ,
                limit: this.page.pageSize,
            }
            let query = {
                
            }
            if(this.page.currentPage != 1){
                query['page'] = this.page.currentPage
            }
            if(this.keywordType && this.keyword != '') {
                option[this.keywordType] = this.keyword
                query['keywordType'] = this.keywordType
                query['keyword'] = this.keyword 
            }
           
            if( !this.valCheck(this.state )  ){
                option['state'] = this.state
                query['state'] = this.state
            }
            if( !this.valCheck(this.contract )  ){
                option['contract'] = this.contract
                query['contract'] = this.contract
            }
            if( !this.valCheck(this.startDate )  ){
                option['date_field'] = this.dateType
                query['date_field'] = this.dateType
                option['date_start'] = this.startDate
                query['date_start'] = this.startDate
            }else{
                delete option['date_start'] 
                delete option['date_end'] 
                delete query.date_start
                delete query.date_end
            }
            this.$router.replace({query: query}).catch((e)=>{});
            this.loadingShow()
            this.$store.dispatch('GET_DDEXJOB', option)
            .then(result =>{
                this.loadingHide()
                console.log(result)
                this.tableData  = result.items // 권리자 목록
                
                this.total = result.total // 총인원수 
                this.filtered = result.filtered // limit에 따른 수
                //페이지 수
                const remainder = parseInt(this.filtered % this.page.pageSize) > 0? 1: 0
                this.page.totalPage = parseInt(this.filtered/this.page.pageSize) + remainder
            }).catch(error=>{
                this.loadingHide()
                const status = error.status
                switch(status){
                    case 401:
                    this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                    break;
                    default:
                    this.alert({msg : error.response.data.message})
                    break;
                }
            })
        },
        
        list_search(){
            this.page.currentPage = 1  // 초기화
            this.callList()
        },
        viewDetail(event){
            this.$router.push('job/detail/'+event)
        },

    }
}
</script>

<style scoped>

</style>
